const DAY_MS = 86_400_000

type DemoWorkspaceShape = {
  is_demo?: boolean | null
  demo_expires_at?: string | null
}

type WorkspaceDemoState = {
  isDemo: boolean
  expiresAt: string | null
}

export const getWorkspaceDemoState = (
  workspace: DemoWorkspaceShape | null | undefined
): WorkspaceDemoState => {
  if (!workspace) {
    return { isDemo: false, expiresAt: null }
  }

  return {
    isDemo: workspace.is_demo === true,
    expiresAt: workspace.demo_expires_at || null
  }
}

export const getWorkspaceDemoDaysLeft = (
  expiresAt: string | null | undefined,
  nowMs: number = Date.now()
): number | null => {
  if (!expiresAt) {
    return null
  }

  const expiresAtMs = Date.parse(expiresAt)
  if (!Number.isFinite(expiresAtMs)) {
    return null
  }

  const diffMs = expiresAtMs - nowMs
  if (diffMs <= 0) {
    return 0
  }

  return Math.ceil(diffMs / DAY_MS)
}
